import { render } from "./BJDial.vue?vue&type=template&id=12a0a5ab"
import script from "./BJDial.vue?vue&type=script&lang=js"
export * from "./BJDial.vue?vue&type=script&lang=js"

import "./BJDial.vue?vue&type=style&index=0&id=12a0a5ab&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__